import { TabItem } from '../tabs/tabs';
import { RemarkTimelineItem, RequoteItem } from './requote-remark-card.model';

export const REQUOTE_REMARK_TABS: TabItem[] = [
  {
    iconName: 'icon-document',
    label: 'Remarks',
    count: 0,
    countBgColor: 'transparent'
  },
  {
    iconName: 'requote_icon',
    label: 'Requotes',
    count: 0,
    countBgColor: 'transparent'
  }
];

export const REMARK_TIMELINE_MOCK: RemarkTimelineItem[] = [
  {
    remark: 'Applicant has pre-existing conditions. Additional medical documents are required.',
    createdOnDate: '2026-03-20T09:30:00',
    modifiedOnDate: '2026-03-20T11:45:00'
  },
  {
    remark: 'Confirmed applicant details and medical history with submitted profile.',
    createdOnDate: '2026-03-20T09:30:00'
  }
];

export const REQUOTE_TIMELINE_MOCK: RequoteItem[] = [
  {
    requestId: 'RQ-002',
    status: 'Declined',
    history: [
      {
        title: 'Request Declined',
        quoteId: 'QT-99281',
        dateTime: '2026-03-15T11:45:00',
        reasonLabel: 'Decline Reason',
        reason: 'Confirmed with client. Submitted DOB does not match passport and correction is pending.',
        avatarUrl: 'assets/images/generic-agent.svg'
      },
      {
        title: 'Request Initiated',
        quoteId: 'QT-99281',
        dateTime: '2026-03-20T09:30:00',
        reasonLabel: 'Requote Reason',
        reason: 'DOB mismatch detected from OCR extraction. Premium recalculation is required.',
        avatarUrl: 'assets/images/generic-agent.svg'
      }
    ]
  },
  {
    requestId: 'RQ-001',
    status: 'Accepted',
    history: [
      {
        title: 'Request Accepted',
        quoteId: 'QT-99281',
        dateTime: '2026-02-17T16:25:00',
        reasonLabel: 'Update Summary',
        reason: 'Client confirmation received and revised quote generated with corrected details.',
        avatarUrl: 'assets/images/generic-agent.svg'
      },
      {
        title: 'Request Initiated',
        quoteId: 'QT-99280',
        dateTime: '2026-02-11T19:00:00',
        reasonLabel: 'Requote Reason',
        reason: 'Gender mismatch found in OCR output and submitted values. Underwriting correction requested.',
        avatarUrl: 'assets/images/generic-agent.svg'
      }
    ]
  }
];
